export default "__VITE_ASSET__CWq43kOj__"